import { getConfig } from '@cian/config/browser';
import { axiosInstance } from './axiosInstance';

export const sendPhone = (phone: string): Promise<{ uuid: string }> => {
  const config = getConfig();
  const mpAuthUrl = config.get<string>('marketplace-auth.mpAuthUrl');

  return axiosInstance.post(`${mpAuthUrl}/phone`, { phone }, { withCredentials: true }).then(r => r.data);
};
